<div class="convo-history">
  <app-page-toolbar
    title="Conversation History"
    icon="history"
    (back)="backToDashboard()"
  >
    <div
      class="plan-number-vis"
      [style.border-color]="isPlanNumberRevealed ? 'green' : 'red'"
    >
      <mat-icon
        matSuffix
        [style.color]="isPlanNumberRevealed ? 'green' : 'red'"
        class="text-sm"
      >
        {{ isPlanNumberRevealed ? 'visibility' : 'visibility_off' }}
      </mat-icon>
      <p>
        {{
          isPlanNumberRevealed ? 'Plan number visible' : 'Plan number hidden'
        }}
      </p>
    </div>
  </app-page-toolbar>

  <div class="date-picker-container mb-4 flex items-center space-x-4">
    <mat-form-field appearance="fill">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" />
      <mat-datepicker-toggle
        matSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" />
      <mat-datepicker-toggle
        matSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Solution Type</mat-label>
      <mat-select [(ngModel)]="solutionType">
        @for (solution of solutionTypeOptions; track solution) {
          <mat-option [value]="solution.value">{{ solution.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Rating</mat-label>
      <mat-select [(ngModel)]="ratingScore">
        @for (score of ratingScoreOptions; track score) {
          <mat-option [value]="score.value">{{ score.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Rating controls</mat-label>
      <mat-select [(ngModel)]="ratingControl">
        @for (control of ratingControlOptions; track control) {
          <mat-option [value]="control.value">{{ control.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      (click)="fetchConversations('fetch')"
    >
      Search
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="fetchConversations('export')"
      [disabled]="!startDate || !endDate || isExporting"
    >
      @if (isExporting) {
        <mat-progress-spinner
          diameter="20"
          mode="indeterminate"
        ></mat-progress-spinner>
      }
      @if (!isExporting) {
        Export Conversations
      }
    </button>
  </div>
  <form
    [formGroup]="planNumberForm"
    (ngSubmit)="searchByPlanNumber()"
    class="mb-4 flex justify-end items-center space-x-4"
  >
    <mat-form-field class="w-full max-w-[250px]">
      <mat-label>Plan Number</mat-label>
      <input
        matInput
        formControlName="planNumber"
        placeholder="Enter Plan Number"
      />
      @if (this.planNumberForm.value.planNumber) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          color="primary"
          (click)="removePlanNumber()"
          [disabled]="isLoadingResults"
          matTooltip="Clear plan number"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">Search</button>
  </form>

  <div class="grid-item">
    @if (isLoadingResults) {
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    }
    @if (!isLoadingResults) {
      <table mat-table [dataSource]="conversations" class="mat-elevation-z8">
        <ng-container matColumnDef="planNumber">
          <th mat-header-cell *matHeaderCellDef>Plan Number</th>
          <td mat-cell *matCellDef="let element">
            <span
              [ngClass]="
                isPlanNumberRevealed
                  ? 'plan-number-revealed'
                  : 'plan-number-blurred'
              "
            >
              {{ element.planNumber }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef>Product Type</th>
          <td mat-cell *matCellDef="let element">
            {{ element.productType }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sessionId">
          <th mat-header-cell *matHeaderCellDef>Session ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.sessionId }}
          </td>
        </ng-container>
        <ng-container matColumnDef="pk">
          <th mat-header-cell *matHeaderCellDef>PK</th>
          <td mat-cell *matCellDef="let element">{{ element.pk }}</td>
        </ng-container>
        <ng-container matColumnDef="sk">
          <th mat-header-cell *matHeaderCellDef>SK</th>
          <td mat-cell *matCellDef="let element">{{ element.sk }}</td>
        </ng-container>
        <ng-container matColumnDef="messageHistory">
          <th mat-header-cell *matHeaderCellDef>Message History</th>
          <td mat-cell *matCellDef="let element">
            <ul>
              @for (message of element.messageHistory; track message) {
                <li>
                  <strong>{{ message.role }}:</strong>
                  {{ message.content?.message ?? message.content?.text }}
                </li>
              }
            </ul>
          </td>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-button
              color="accent"
              (click)="viewConversation(element)"
            >
              View
            </button>
            <button
              mat-button
              color="primary"
              (click)="viewTriageConversation(element)"
              matTooltip="View full triage conversation"
            >
              Triage View
            </button>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="flex items-center gap-2 py-4">
              <span>
                <mat-icon>error_outline</mat-icon>
                <p>
                  No conversations with the Plan Number
                  {{ planNumberForm.value.planNumber }} found.
                </p></span
              >
            </div>
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }

    @if (this.conversations.data.length !== 0) {
      <mat-paginator
        aria-label="Select page of periodic elements"
        (page)="fetchBedrockConversations($event)"
        [length]="resultsLength"
        [pageSize]="10"
        showFirstLastButtons="false"
        [pageSizeOptions]="[5, 10, 25, 100, 500, 1000, 2000, 5000]"
        [pageIndex]="currentPage"
        hasPreviousPage="false"
      >
      </mat-paginator>
    }
  </div>

  <!-- Advanced Log Exporter Component & PO Tips -->
  <div class="log-exporter-section">
    <mat-card class="po-tips-card">
      <mat-card-content class="po-tips-content">
        <div class="po-tips-header">
          <mat-icon>help_outline</mat-icon>
          <strong>How Product Owners (POs) Can Use This Widget:</strong>
        </div>
        <ul class="po-tips-list">
          <li>
            <strong>Prevent Timeouts:</strong> If exporting massive date ranges
            (e.g. 1 month+), fetch in smaller chunks (like 4-day increments) to
            keep the gateway healthy.
          </li>
          <li>
            <strong>Maintain Data Compliance:</strong> Keep
            <code>Partition Key (pk)</code> and <code>Plan Number</code>
            deselected to produce completely clean, anonymous exports.
          </li>
          <li>
            <strong>Get Readable Reports:</strong> Use the
            <strong>"Export HTML Report"</strong> option to generate a
            standalone web report showcasing the AI Summaries and user Feedback
            side-by-side in structured, easy-to-read cards.
          </li>
        </ul>
      </mat-card-content>
    </mat-card>

    <app-log-exporter></app-log-exporter>
  </div>
</div>
